import axios from 'axios'
import { store } from './store'


const getAPI = axios.create({
  baseURL: '/'
})

  getAPI.interceptors.response.use( (response) => {
    // Return a successful response back to the calling service
    return response;
  }, (error) => {
    // Return any error which is not due to authentication back to the calling service
    if (error.response.status !== 401) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
    return store.dispatch('refreshToken')
      .then((token) => {

        // New request with new token
        const config = error.config;
        config.headers = { Authorization: `Bearer ${store.state.accessToken}` }

        return new Promise((resolve, reject) => {
          axios.request(config).then(response => {
            resolve(response);
          }).catch((error) => {
            reject(error);
          })
        });

      })
      .catch((error) => {
      	Promise.reject(error);
      });
  });




export { getAPI }




// WEBPACK FOOTER //
// ./src/store/axios-base.js